import {FETCHSKU_CONFIGVEHICULO,FETCHSKU_EQUIPOVEHICULO,FETCHSKU_CARTECVEHICULO,FETCHSKU_ESPTECVEHICULO, 
  FETCHSKU_ACCADUVEHICULO,FETCHSKU_IMGVEHICULO,FETCHSKU_EQUISEGVEHICULO,LOAD_MANTENIMIENTO,
  FETCHSKU_INSERT_EQUISEGVEH, FETCHSKU_DELETE_EQUISEGVEH,
  FETCHSKU_INSERT_IMAGENVEH, FETCHSKU_DELETE_IMAGENVEH,
  FETCHSKU_LIST_TIPOIMAGEN, FETCHSKU_LIST_CONFIGURACION,
  FETCHSKU_UPDATE_CARTECVEH, FETCHSKU_INSERT_CARTECVEH,
  FETCHSKU_LIST_TBCARACTECNI, FETCHSKU_DELETE_CARTECVEH,
  FETCHSKU_RUTA_FIREBASE, FETCHSKU_UPDATE_EQUISEGVEH,
  FETCHSKU_UPDATE_IMAGENVEH, FETCHSKU_CODAUTO_IMAGEN} from '../actions';

export default function(state = null, action) {
  switch (action.type) {
    case FETCHSKU_CONFIGVEHICULO:     return action.payload.data;
    case FETCHSKU_EQUIPOVEHICULO:     return action.payload.data;
    case FETCHSKU_CARTECVEHICULO:     return action.payload.data;
    case FETCHSKU_ESPTECVEHICULO:     return action.payload.data;
    case FETCHSKU_ACCADUVEHICULO:     return action.payload.data;
    case FETCHSKU_IMGVEHICULO:        return action.payload.data;
    case FETCHSKU_EQUISEGVEHICULO:    return action.payload.data;
    case FETCHSKU_INSERT_EQUISEGVEH:  return action.payload.data;
    case FETCHSKU_DELETE_EQUISEGVEH:  return action.payload.data;
    case FETCHSKU_INSERT_IMAGENVEH:   return action.payload.data;
    case FETCHSKU_DELETE_IMAGENVEH:   return action.payload.data;
    case FETCHSKU_LIST_TIPOIMAGEN:    return action.payload.data;
    case FETCHSKU_LIST_CONFIGURACION: return action.payload.data;
    case FETCHSKU_UPDATE_CARTECVEH:   return action.payload.data;
    case FETCHSKU_INSERT_CARTECVEH:   return action.payload.data;
    case FETCHSKU_LIST_TBCARACTECNI:  return action.payload.data;    
    case FETCHSKU_DELETE_CARTECVEH:   return action.payload.data;
    case FETCHSKU_RUTA_FIREBASE:      return action.payload.data;
    case FETCHSKU_UPDATE_EQUISEGVEH:  return action.payload.data;
    case FETCHSKU_UPDATE_IMAGENVEH:   return action.payload.data;
    case FETCHSKU_CODAUTO_IMAGEN :    return action.payload.data;
    case LOAD_MANTENIMIENTO:          return null;
    default:   return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/MantenimientoSkuVehiculo.js